module.exports = {"TXTWCL_Singles":{"id":"TXTWCL_Singles","defaultMessage":"Jednoduché","track":"Singles","ontario":"Sázky na jedno číslo"}}